import { PropType, defineComponent, onUnmounted, inject, ref, watch, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Tracker from '@nio-fe/nio-tracker-web'
import styles from './styles.module.scss'
import { Store } from 'pinia'
import { clearHistory } from '../../../router'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import { useAppStore } from '../../../stores/app'
import { Popover } from 'vant'
import { DEFAULT_POSITION } from '../../../config/defaultPosition'
import { isInApp } from '@nio-wad/hooks'
import { nioJsBridge } from '@nio-wad/universal-bridge-h5'
import { OS } from '@/utils/device'

export default defineComponent({
  name: 'action-bar',
  emits: ['handleFilter', 'hideFilter', 'goBackHome'],
  components: {
    [Popover.name]: Popover,
  },
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const appStore = useAppStore()
    // const componentStore = useComponentStore()
    const router = useRouter()
    const route = useRoute()

    const client = inject<string>('client', '')

    // 更多操作
    const showPopover = ref<boolean>(false)

    const actionBarConfig = ref<{ [x: string]: any }[]>([])
    const innerBarConfig = ref<{ [x: string]: any }[]>([])

    const actionBarNum = ref<number>(0)

    /**
     * 由于北极星配置项较多，需要筛选出指定场景（操作栏）进行处理
     * actionBarWhiteList: 操作栏白名单
     * 即会展示在操作栏中的配置项
     * 北极星配置项 - 默认不配置actionBarWhiteList
     */
    const actionBarWhiteList: string[] = componentsConfig?.menu?.properties
      ?.action_bar_white_list || [
      'route_plan',
      'data_cards',
      'wishpower',
      'around_resources',
      'mock_swap',
      'new_station',
      'county_layout',
    ] // 新增的操作栏需要在此添加code

    const resolveConfig = (configList: string[]) => {
      try {
        return configList.reduce((item: { [x: string]: any }[], key: string) => {
          const config = componentsConfig[key]
          if (config && config.show) {
            item.push({ [key]: config })
          }
          return item
        }, [])
      } catch (err) {
        console.error(`Error: ${err}`)
        return []
      }
    }
    const totalBarConfig = resolveConfig(actionBarWhiteList) || ([] as { [x: string]: any }[])
    // actionBarNum = client !== 'mobile' ? 4 : 3
    if (client !== 'mobile') {
      actionBarNum.value = totalBarConfig.length > 4 ? 3 : totalBarConfig.length
    } else {
      actionBarNum.value = totalBarConfig.length > 3 ? 2 : totalBarConfig.length
    }

    /**
     * 处理不同场景下 操作栏-更多包含的操作
     * 1. PC右侧功能按钮多于四个-展示三个+更多
     * 2. 移动端右侧功能按钮多于三个-展示2个+更多
     * 3. 中卡位全部收起
     */
    const sceneConfig = (num = 0) => {
      actionBarConfig.value = totalBarConfig.slice(0, num) || []
      innerBarConfig.value = totalBarConfig.slice(num) || []
    }

    const handlePath = async () => {
      clearHistory()
      handleSelect()
      props.componentStore.bus.emit('clearAllMarkers') // 清空ICON
      props.componentStore.bus.emit('handleHomeSearchClear') // 清空搜索
      props.componentStore.bus.emit('forceClearBackList') // 清空后退列表
      props.componentStore.bus.emit('handleBlingClear') // 打断已经开始的动画效果
      setTimeout(() => {
        router.push('/journey/recommend')
        // 若筛选看板打开则关闭
        props.componentStore.filterPanel && props.componentStore.bus.emit('closeFilterPanel')
        // 若搜索看板打开则关闭
        props.componentStore.searchListPanel &&
          props.componentStore.bus.emit('closeSearchListPanel')
        props.componentStore.triggerPanel()
        // 路线点击埋点
        Tracker.track('nsh5_roadmapclick', appStore.trackParamsCommon)
      }, 500)
    }

    const handleData = () => {
      clearHistory()
      handleSelect()
      props.componentStore.bus.emit('clearBackList') // 根据搜索条件，清空后退列表
      setTimeout(() => {
        window.backHistoryNum++
        router.push({
          name: 'data_summary',
          state: {
            backHistoryNum: window.backHistoryNum,
          },
        })
        // 若筛选看板打开则关闭
        props.componentStore.filterPanel && props.componentStore.bus.emit('closeFilterPanel')
        // 若搜索看板打开则关闭
        props.componentStore.searchListPanel &&
          props.componentStore.bus.emit('closeSearchListPanel')
        props.componentStore.triggerPanel()
        // 数据点击埋点
        Tracker.track('nsh5_citymapclickdata', appStore.trackParamsCommon)
        return
      }, 500)
    }

    const handleWishPower = () => {
      clearHistory()
      handleSelect()
      props.componentStore.bus.emit('clearAllMarkers') // 清空ICON
      props.componentStore.bus.emit('handleHomeSearchClear') // 清空搜索
      props.componentStore.bus.emit('forceClearBackList') // 清空后退列表
      props.componentStore.bus.emit('handleBlingClear') // 打断已经开始的动画效果
      setTimeout(() => {
        window.backHistoryNum++
        router.push({
          name: 'wishpower_index',
          state: {
            backHistoryNum: window.backHistoryNum,
          },
        })
        // 若筛选看板打开则关闭
        props.componentStore.filterPanel && props.componentStore.bus.emit('closeFilterPanel')
        // 若搜索看板打开则关闭
        props.componentStore.searchListPanel &&
          props.componentStore.bus.emit('closeSearchListPanel')
        props.componentStore.triggerPanel()
        // 埋点-心愿站点击
        Tracker.track('h5_page_tracker', {
          channel: window.channel,
          client: window.client,
          brand: (process.config as any).brand,
          screen_orientation: window.screen_orientation,
          view_mode: props.componentStore.viewMode,
          container: window.container,
          user_identity: window.user_identity,
          trigger: 'click',
          element: '操作栏-心愿站按钮',
          page_source: window.page_source,
        })
      }, 500)
    }

    // 20240523-新增操作栏-附近资源
    const handleResources = async () => {
      clearHistory()
      handleSelect()
      handleLocation()
      props.componentStore.bus.emit('preventZoomDragAction', 3000)
      props.componentStore.bus.emit('handleHomeSearchClear') // 清空搜索
      props.componentStore.bus.emit('forceClearBackList') // 清空后退列表
      props.componentStore.bus.emit('handleBlingClear') // 打断已经开始的动画效果
      setTimeout(() => {
        changeRouteFn()
        // 若筛选看板打开则关闭
        props.componentStore.filterPanel && props.componentStore.bus.emit('closeFilterPanel')
        // 若搜索看板打开则关闭
        props.componentStore.searchListPanel &&
          props.componentStore.bus.emit('closeSearchListPanel')
        props.componentStore.triggerPanel()
      }, 500)
    }

    const handleLocation = () => {
      props.componentStore.bus.emit('handleLocation')
    }

    // loc.lng, loc.lat
    const changeRouteFn = async () => {
      if (route.name == 'home') {
        window.backHistoryNum++
        await router.push({
          name: 'around_resource',
          state: {
            backHistoryNum: window.backHistoryNum,
          },
        })
      } else {
        await router.replace({
          name: 'around_resource',
          state: {
            backHistoryNum: window.backHistoryNum,
          },
        })
      }
      const myLoc = props.componentStore.myLocation || DEFAULT_POSITION
      props.componentStore.setDestLocationByPin({
        name: '',
        lng: myLoc.lng,
        lat: myLoc.lat,
      })

      // 重新设置destLocation
      props.componentStore.$patch({
        cardLoaded: true,
      })
    }

    props.componentStore.bus.on('selectedPin', () => {
      props.componentStore.$patch({
        cardLoaded: false,
      })
    })

    const handleMockSwap = () => {
      handleSelect()
      window.open(componentsConfig.mock_swap.properties.url)
    }

    const handleNewStation = async () => {
      if (isInApp) {
        // app内打开今日上新
        const brand = (process.config as any).brand
        const schemeMap: Record<string, string> = OS.isAndroid
          ? {
              // 因为android设备不支持打开地图再打开一个地图，所以用一个特别的scheme
              nio: 'nio://service/charge_map_multi?detail_modal=new_station',
              alps: 'onvo://mapmodule/maphome_journey?detail_modal=new_station',
              fy: 'fy://mapmodule/maphome_journey?detail_modal=new_station',
            }
          : {
              nio: 'nio://service/charge_map?detail_modal=new_station',
              alps: 'onvo://mapmodule/maphome?detail_modal=new_station',
              fy: 'fy://mapmodule/maphome?detail_modal=new_station',
            }
        const link = schemeMap[brand]
        nioJsBridge.openURL({
          data: {
            url: link,
          },
        })
      } else {
        clearHistory()
        handleSelect()
        props.componentStore.bus.emit('clearAllMarkers') // 清空ICON
        props.componentStore.bus.emit('handleHomeSearchClear') // 清空搜索
        props.componentStore.bus.emit('forceClearBackList') // 清空后退列表
        props.componentStore.bus.emit('handleBlingClear') // 打断已经开始的动画效果

        props.componentStore.bus.emit('preventZoomDragAction', 3000) // 阻止面板自动收起
        setTimeout(() => {
          window.backHistoryNum++
          router.push({
            name: 'newStation',
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          })
          // 若筛选看板打开则关闭
          props.componentStore.filterPanel && props.componentStore.bus.emit('closeFilterPanel')
          // 若搜索看板打开则关闭
          props.componentStore.searchListPanel &&
            props.componentStore.bus.emit('closeSearchListPanel')
          props.componentStore.triggerPanel()
          // 埋点
          Tracker.track('h5_page_tracker', {
            channel: window.channel,
            client: window.client,
            brand: (process.config as any).brand,
            screen_orientation: window.screen_orientation,
            view_mode: props.componentStore.viewMode,
            container: window.container,
            user_identity: window.user_identity,
            trigger: 'click',
            element: '操作栏-新站上新按钮',
            page_source: window.page_source,
          })
        }, 500)
      }
    }

    // 县县通
    const handleCountyLayout = async () => {
      clearHistory()
      handleSelect()
      props.componentStore.bus.emit('clearAllMarkers') // 清空ICON
      props.componentStore.bus.emit('handleHomeSearchClear') // 清空搜索
      props.componentStore.bus.emit('forceClearBackList') // 清空后退列表
      props.componentStore.bus.emit('handleBlingClear') // 打断已经开始的动画效果

      props.componentStore.bus.emit('preventZoomDragAction', 3000) // 阻止面板自动收起
      props.componentStore.$patch({
        countyLayoutConfig: {
          currentIndex: 0,
        },
      })
      setTimeout(() => {
        window.backHistoryNum++
        router.push({
          name: 'countyLayout',
          state: {
            backHistoryNum: window.backHistoryNum,
          },
        })
        // 若筛选看板打开则关闭
        props.componentStore.filterPanel && props.componentStore.bus.emit('closeFilterPanel')
        // 若搜索看板打开则关闭
        props.componentStore.searchListPanel &&
          props.componentStore.bus.emit('closeSearchListPanel')
        props.componentStore.triggerPanel()
        // 埋点
        Tracker.track('h5_page_tracker', {
          channel: window.channel,
          client: window.client,
          brand: (process.config as any).brand,
          screen_orientation: window.screen_orientation,
          view_mode: props.componentStore.viewMode,
          container: window.container,
          user_identity: window.user_identity,
          trigger: 'click',
          element: '操作栏-县县通按钮',
          page_source: window.page_source,
        })
      }, 500)
    }

    // 更多操作
    const handleSelect = () => {
      showPopover.value = false
      props.componentStore.$patch({
        showPhonePopover: false,
      })
    }

    watch(
      () => props.componentStore.popupDragLevel,
      () => {
        if (props.componentStore.popupDragLevel > 0 && client === 'mobile') {
          if (actionBarNum.value > 1) {
            sceneConfig(0)
          } else {
            sceneConfig(actionBarNum.value)
          }
        } else {
          sceneConfig(actionBarNum.value)
        }
      },
      {
        immediate: true,
      }
    )

    onUnmounted(() => {
      // props.componentStore.bus.emit('forceClearBackList')
    })

    const iconPx = () => {
      const $px = client === 'mobile' ? '20px' : '24px'
      return $px
    }

    const showCountyLayoutRedDot = computed(() => props.componentStore.showCountyLayoutRedDot)

    return () => {
      return (
        <div class={styles.handleBoxRight}>
          {actionBarConfig.value.map((item) => (
            <>
              {item?.route_plan?.show ? (
                <div class="icon" onClick={handlePath}>
                  <ns-icon name={(process.config as any).icon.icon_path_plan} size={iconPx()} />
                  路线
                </div>
              ) : null}
              {item?.data_cards?.show ? (
                <div class="icon" onClick={handleData}>
                  <ns-icon name={(process.config as any).icon.data_outline} size={iconPx()} />
                  数据
                </div>
              ) : null}
              {item?.around_resources?.show ? (
                <div class="icon" onClick={handleResources}>
                  <ns-icon name={(process.config as any).icon.powermap} size={iconPx()} />
                  {client !== 'mobile' ? <span>附近资源</span> : null}
                </div>
              ) : null}
              {item?.wishpower?.show ? (
                <div class="icon" onClick={handleWishPower}>
                  <ns-icon name={(process.config as any).icon.icon_likes} size={iconPx()} />
                  {client !== 'mobile' ? <span>换电心愿单</span> : <span>心愿单</span>}
                </div>
              ) : null}
              {item?.mock_swap?.show ? (
                <div class="icon" onClick={handleMockSwap}>
                  <ns-icon name={(process.config as any).icon.power_swap} size={iconPx()} />
                  <span>模拟换电</span>
                </div>
              ) : null}
              {item?.new_station?.show ? (
                <div class="icon" onClick={handleNewStation}>
                  <ns-icon name={(process.config as any).icon.power_swap} size={iconPx()} />
                  <span>上新</span>
                </div>
              ) : null}
              {item?.county_layout?.show ? (
                <div class="icon" onClick={handleCountyLayout}>
                  <ns-icon name={(process.config as any).icon.icon_county} size={iconPx()} />
                  <span>县县通</span>
                  {isInApp && showCountyLayoutRedDot.value ? (
                    <div class={styles.redDot}></div>
                  ) : null}
                </div>
              ) : null}
            </>
          ))}
          {innerBarConfig.value.length > 4 ? (
            <Popover
              v-model:show={showPopover.value}
              class={[styles.PopoverIcon, client !== 'mobile' && styles.PopoverIconPC]}
              placement={client !== 'mobile' ? 'bottom-end' : 'left-start'}
            >
              {{
                default: () => (
                  <>
                    {innerBarConfig.value.map((item) => (
                      <>
                        {item?.route_plan?.show ? (
                          <div class="icon" onClick={handlePath}>
                            路线
                          </div>
                        ) : null}
                        {item?.data_cards?.show ? (
                          <div class="icon" onClick={handleData}>
                            数据
                          </div>
                        ) : null}
                        {item?.wishpower?.show ? (
                          <div class="icon" onClick={handleWishPower}>
                            换电心愿单
                          </div>
                        ) : null}
                        {item?.around_resources?.show ? (
                          <div class="icon" onClick={handleResources}>
                            附近资源
                          </div>
                        ) : null}
                        {item?.mock_swap?.show ? (
                          <div class="icon" onClick={handleMockSwap}>
                            模拟换电
                          </div>
                        ) : null}
                        {item?.new_station?.show ? (
                          <div class="icon" onClick={handleNewStation}>
                            今日上新
                          </div>
                        ) : null}
                        {item?.county_layout?.show ? (
                          <div class="icon" onClick={handleCountyLayout}>
                            县县通
                          </div>
                        ) : null}
                      </>
                    ))}
                  </>
                ),
                reference: () =>
                  (totalBarConfig.length > 3 && client === 'mobile') ||
                  (totalBarConfig.length > 4 && client !== 'mobile') ||
                  (props.componentStore.popupDragLevel > 0 &&
                    client === 'mobile' &&
                    totalBarConfig.length > 1) ? (
                    <div
                      class={[
                        'icon',
                        client !== 'mobile' && styles.iconPC,
                        props.componentStore.popupDragLevel > 0 &&
                        client === 'mobile' &&
                        totalBarConfig.length > 1
                          ? styles.onlyMoreIcon
                          : '',
                      ]}
                    >
                      <ns-icon name={(process.config as any).icon.more} size={iconPx()} />
                      更多
                    </div>
                  ) : null,
              }}
            </Popover>
          ) : null}
        </div>
      )
    }
  },
})
